module.exports = __webpack_public_path__ + "static/media/ticket-white.fdfd287f.svg";